import React from 'react';
import './index.scss';
import {owner, card01, card02, card03, card04} from '../../assets/cloudinaryUrls.js';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

function Owners() {

        return(
            <>
               <div className='about-banner'>
        <div className='img-wrapper'>
          <div className='img-text owners flex-clmn'>
            <h4><FormattedMessage id="owner.banner.title" /></h4>
            <h6><FormattedMessage id="owner.banner.subtitle" /></h6>
            <Link to="/about" className='home-button anim-btn prop-btn'><FormattedMessage id="owner.submit_house" /></Link>
          </div>
          <img src={owner} alt='na' className='about-img anim' /> 
        </div>
      </div>
      <div className='services'>
        <div className='serv-content flex-clmn div-prop'>
          <div className='serv-card flex-row'>
            <div className='serv-block flex-clmn div-prop'>
              <div className='flex-row headline-card'>
                <div className='line line-card'></div>
                <h5><FormattedMessage id="owner.listing_marketing.title" /></h5>
              </div>
              <p><FormattedMessage id="owner.listing_marketing.description" /></p>
            </div>
            <img src={card02} alt='na' className='serv-img anim' /> 
          </div>
          <div className='serv-card flex-row'>
            <img src={card01} alt='na' className='serv-img anim' />
            <div className='serv-block flex-clmn div-prop'>
              <div className='flex-row headline-card'>
                <div className='line line-card'></div>
                <h5><FormattedMessage id="owner.property_valuation.title" /></h5>
              </div>
              <p><FormattedMessage id="owner.property_valuation.description" /></p>
            </div>
          </div>
          <div className='serv-card flex-row'>
            <div className='serv-block flex-clmn div-prop'>
              <div className='flex-row headline-card'>
                <div className='line line-card'></div>
                <h5><FormattedMessage id="owner.home_staging.title" /></h5>
              </div>
              <p><FormattedMessage id="owner.home_staging.description" /></p>
            </div>
            <img src={card03} alt='na' className='serv-img anim' />
          </div>
          <div className='serv-card flex-row'>
            <img src={card04} alt='na' className='serv-img anim' /> 
            <div className='serv-block flex-clmn div-prop'>
              <div className='flex-row headline-card'>
                <div className='line line-card'></div>
                <h5><FormattedMessage id="owner.strategic_selling.title" /></h5>
              </div>
              <p><FormattedMessage id="owner.strategic_selling.description" /></p>
            </div>
          </div>
        </div>
      </div>
            </>
        )
    }

export default Owners